import React, {useState} from 'react';

export const ContentOlvContraseña = (props) => {
	const {goToLogin, enviarCorreoCodigo, estadoRecuperarContraseña, consultarCorreo} = props;

	const [correo, setCorreo] = useState('');

	const comprobarCorreo = () =>{
		consultarCorreo(correo)
	}

	return (
		<div className='ContentOlvContraseña'>
			<div className='centrador'>¿Ha olvidado su contraseña?</div>
			<div className='inputCorreoOlvidarContraseña'>
				{estadoRecuperarContraseña === 2 && (
					<div className='centrador correroInvalido'>El correo ingresado no existe</div>
				)}
				<input
					type='email'
					placeholder='Correro electrónico'
					className='usernameFormularioLoginStandar inputFormularioLoginStandar inputTextUsuario'
					value={correo}
					onChange={(e) => setCorreo(e.target.value)}
				/>
			</div>
			<div className='centrador'>
				<div
					className='button'
					onClick={comprobarCorreo}
				>
					<b>Restablecer</b>
				</div>
			</div>
			<div className='centrador'>
				<div className='barraSeparadorContentBodyLoginInterno' />
			</div>
			<div className='centrador linkRestablecerContraseña'>
				<div> o </div>
				<b onClick={goToLogin}> inicia sesión</b>
			</div>
		</div>
	);
};
